export default class LifecycleService {}
